import httpRequest from '@/utils/request';

const permissionUrl = '/Permission';
const updateUserUrl = (permissionId: string) => {
  return `/Permission/${permissionId}/user`;
};
const updateRoleUrl = (permissionId: string) => {
  return `/Permission/${permissionId}/role`;
};

export const getPermissions = (
  params: IPermission.IRequest.IGetPermission = {},
): Promise<IPermission.IResponse.IData> => {
  return httpRequest.get(permissionUrl, {
    params,
  });
};
export const addUsers = (
  params: IPermission.IRequest.IUpdateUsers,
): Promise<IResponseData.IBaseData> => {
  const url = updateUserUrl(params.permissionId);
  return httpRequest.post(url, params.userIds);
};
export const delUsers = (
  params: IPermission.IRequest.IUpdateUsers,
): Promise<IResponseData.IBaseData> => {
  const url = updateUserUrl(params.permissionId);
  return httpRequest.delete(url, {
    data: params.userIds,
  });
};
export const addRoles = (
  params: IPermission.IRequest.IUpdateRoles,
): Promise<IResponseData.IBaseData> => {
  const url = updateRoleUrl(params.permissionId);
  return httpRequest.post(url, params.roleIds);
};
export const delRoles = (
  params: IPermission.IRequest.IUpdateRoles,
): Promise<IResponseData.IBaseData> => {
  const url = updateRoleUrl(params.permissionId);
  return httpRequest.delete(url, {
    data: params.roleIds,
  });
};
